import * as yup from 'yup';

export const BookAuthorValidation = yup.object().shape({
    idAuthor: yup.string().required('Campo é obrigatória'),
    idBook: yup.string().required('Campo é obrigatória'),
});